<script setup>
import { myTicketsUrl, reportProblemUrl, routePattern, SUPPORT_SYSTEM } from '@/helpers/reportProblem'

// Nút «Hỗ trợ» ở thanh trên (vims-docs/docs/modules/ho-tro, standards design/patterns/help-menu.md bản gọn 24/10/2026).
// Cách 07.2 mục 5.5: mở trang MyVNC ở tab mới. Thiếu NUXT_PUBLIC_MYVNC_URL thì không hiện (công tắc).

const config = useRuntimeConfig()
const route = useRoute()

const baseUrl = computed(() => (config.public.myvncUrl || '').trim())

// Dựng lúc bấm để `screen` là màn đang mở và `at` là lúc bấm.
const openReport = () => {
  const url = reportProblemUrl({
    baseUrl: baseUrl.value,
    system: SUPPORT_SYSTEM,
    kind: 'BUG',
    screen: routePattern(route.matched.at(-1)?.path),
    version: config.public.gitSha || undefined,
  })

  window.open(url, '_blank', 'noopener,noreferrer')
}

const ticketsHref = computed(() => myTicketsUrl(baseUrl.value))

// Chú thích chỉ hiện khi menu đóng, không đè lên mục đầu của menu.
const menuOpen = ref(false)
</script>

<template>
  <VBtn
    v-if="baseUrl"
    variant="text"
    color="default"
    class="nav-help-btn text-medium-emphasis me-2"
    aria-label="Hỗ trợ"
  >
    <VIcon
      icon="tabler-help-circle"
      size="20"
    />
    <span class="d-none d-md-inline ms-1">Hỗ trợ</span>
    <VTooltip
      activator="parent"
      location="bottom"
      :disabled="menuOpen"
    >
      Hỗ trợ, báo lỗi, góp ý
    </VTooltip>
    <VMenu
      v-model="menuOpen"
      activator="parent"
      width="288"
      max-width="calc(100vw - 32px)"
      location="bottom end"
      offset="10px"
    >
      <VList density="compact">
        <VListItem
          class="py-2"
          @click="openReport"
        >
          <template #prepend>
            <VIcon
              icon="tabler-message-report"
              size="18"
              class="text-medium-emphasis align-self-start mt-1"
            />
          </template>
          <VListItemTitle class="font-weight-medium">
            Báo lỗi, góp ý
          </VListItemTitle>
          <VListItemSubtitle class="text-caption">
            Lỗi, cần hỗ trợ, đề xuất làm tốt hơn
          </VListItemSubtitle>
          <template #append>
            <VIcon
              icon="tabler-external-link"
              size="16"
              class="text-medium-emphasis"
              aria-label="Mở tab mới"
            />
          </template>
        </VListItem>
        <VListItem
          class="py-2"
          :href="ticketsHref"
          target="_blank"
          rel="noopener noreferrer"
        >
          <template #prepend>
            <VIcon
              icon="tabler-inbox"
              size="18"
              class="text-medium-emphasis"
            />
          </template>
          <VListItemTitle>Phiếu hỗ trợ của tôi</VListItemTitle>
          <template #append>
            <VIcon
              icon="tabler-external-link"
              size="16"
              class="text-medium-emphasis"
              aria-label="Mở tab mới"
            />
          </template>
        </VListItem>
      </VList>
    </VMenu>
  </VBtn>
</template>

<style scoped>
.nav-help-btn {
  text-transform: none;
  letter-spacing: normal;
}

@media (max-width: 959px) {
  .nav-help-btn {
    min-inline-size: 0;
    padding-inline: 8px;
  }
}
</style>
